import { headersAuth, headersAuthReceiveJson, headersAuthSendReceiveJson } from '../headers';
import { apiHandleResponse } from '../../util/api';
import { METHOD_DELETE, METHOD_GET, METHOD_POST, METHOD_PUT, SERVER_URL } from '../constants/api';
import { http } from './common';

const getProvidersList = (options) => {
    return fetch(`${SERVER_URL}/api/v1/cms/providers`, {
        method: METHOD_POST,
        headers: headersAuthSendReceiveJson(),
        body: JSON.stringify(options),
    }).then(apiHandleResponse);
};

const createProvider = (data) => {
    return fetch(`${SERVER_URL}/api/v1/cms/provider`, {
        method: METHOD_POST,
        headers: headersAuthSendReceiveJson(),
        body: JSON.stringify(data)
    }).then(apiHandleResponse);
}

const getProvider = (id) => {
    return fetch(`${SERVER_URL}/api/v1/cms/provider/${id}`, {
        method: METHOD_GET,
        headers: headersAuthReceiveJson(),
    }).then(apiHandleResponse);
};

const updateProvider = (data) => {
    return fetch(`${SERVER_URL}/api/v1/cms/provider`, {
        method: METHOD_PUT,
        headers: headersAuthSendReceiveJson(),
        body: JSON.stringify(data),
    }).then(apiHandleResponse);
};

const deleteProvider = (id) => {
    return fetch(`${SERVER_URL}/api/v1/cms/provider/${id}`, {
        method: METHOD_DELETE,
        headers: headersAuthReceiveJson(),
    }).then(apiHandleResponse);
};

const downloadReport = async (payload) => {
    return http.post(`/api/v1/cms/provider/export`, payload, 'octet-stream' );
};

const importProviders = (csvFile) => {
    const formData = new FormData();
    formData.append('providersCSV', csvFile);
    return fetch(`${SERVER_URL}/api/v1/cms/provider/import`, {
        method: METHOD_POST,
        headers: headersAuth(),
        body: formData,
    }).then(apiHandleResponse);
};

const updateStatus = (payload) => {
    return fetch(`${SERVER_URL}/api/v1/cms/providers/status`, {
        method: METHOD_POST,
        headers: headersAuthSendReceiveJson(),
        body: JSON.stringify(payload)
    }).then(apiHandleResponse);
};

const updateStatusByCriteria = (payload, enabled) => {
    return fetch(`${SERVER_URL}/api/v1/cms/providers/filter/status/${enabled}`, {
        method: METHOD_POST,
        headers: headersAuthSendReceiveJson(),
        body: JSON.stringify(payload)
    }).then(apiHandleResponse);
};

const searchFromNPIRegistry = (npi) => {
    return fetch(`${SERVER_URL}/api/v1/cms/provider/npiregistry/${npi}`, {
        method: METHOD_GET,
        headers: headersAuthReceiveJson(),
    }).then(apiHandleResponse);
};

const updateProviderNPIRole = (payload) => {
    return fetch(`${SERVER_URL}/api/v1/cms/providers/role`, {
        method: METHOD_POST,
        headers: headersAuthSendReceiveJson(),
        body: JSON.stringify(payload)
    }).then(apiHandleResponse);
};

const bulkSearchFromNPIRegistry = (payload) => {
    return fetch(`${SERVER_URL}/api/v1/cms/provider/bulk/npilookup`, {
        method: METHOD_POST,
        headers: headersAuthSendReceiveJson(),
        body: JSON.stringify(payload)
    }).then(apiHandleResponse);
};

const createBulkProviders = (payload) => {
    return fetch(`${SERVER_URL}/api/v1/cms/provider/bulk/add`, {
        method: METHOD_POST,
        headers: headersAuthSendReceiveJson(),
        body: JSON.stringify(payload)
    }).then(apiHandleResponse);
};

export {
    getProvidersList, createProvider, getProvider, updateProvider, deleteProvider, downloadReport, importProviders, updateStatus, updateStatusByCriteria, searchFromNPIRegistry, updateProviderNPIRole, bulkSearchFromNPIRegistry, createBulkProviders
};
